import { Box, Chip, SvgIcon } from '@mui/material';
import { LocalShippingOutlined } from '@mui/icons-material';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Business_Profile_Enum, Contract_Status_Enum } from '@kheops/graphql';
import CompanyDistanceChip from '../common/components/CompanyDistanceChip';
import MinimumOrderValueChip from '../common/components/MinimumOrderValueChip';
import { currentContextAtom } from '../state';
import { ContractPreview } from '../hooks/useContracts';
import CommissionInfo from '../common/components/CommissionInfo';
import { MinimumOrderValue } from '../common/state/state';
import { getMinimumOrderValueFromDeliveryZones } from '../common/utils/common.utils';
import { CompanyInfo } from './companyInfo/CompanyInfoCard';

interface CompanyInfoChipsProps {
  company: CompanyInfo;
  contract?: ContractPreview;
  canDeliver?: boolean;
}

export default function CompanyInfoChips({ company, contract, canDeliver }: CompanyInfoChipsProps): React.JSX.Element {
  const { t } = useTranslation(['discovery']);
  const { companyAddress, realm } = useAtomValue(currentContextAtom);
  let minimumOrderValue: MinimumOrderValue | undefined;

  if (contract?.status !== Contract_Status_Enum.Signed) {
    minimumOrderValue = getMinimumOrderValueFromDeliveryZones(company.delivery_zones, companyAddress.administrativeAreaLevel2!);
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 0.5,
        '& .MuiChip-root:not(.warning-chip)': {
          backgroundColor: 'surfaceContainerHigh.main',
        },
      }}
    >
      {realm === Business_Profile_Enum.Supplier && canDeliver === false && (
        <Chip
          className="warning-chip"
          variant="tag"
          color="warningContainer"
          icon={(
            <SvgIcon
              component={LocalShippingOutlined}
              inheritViewBox
            />
          )}
          label={t('discovery:out_of_your_delivery_zones')}
          sx={{
            pr: 1.5,
          }}
        />
      )}
      {contract?.status !== Contract_Status_Enum.Signed && (
        <CompanyDistanceChip targetGeoLoc={{ lat: company.addresses[0].latitude, lng: company.addresses[0].longitude }} />
      )}
      {minimumOrderValue?.value !== undefined && (
        <MinimumOrderValueChip minimumOrderValue={minimumOrderValue.value} minimumOrderValueType={minimumOrderValue.type} />
      )}
      {realm === Business_Profile_Enum.Supplier && !!contract?.supplier_commission_rate && (
        <CommissionInfo short commission={contract.supplier_commission_rate} />
      )}
    </Box>
  );
}
